import { render, staticRenderFns } from "./postTwitter.vue?vue&type=template&id=18ecc3cc&"
import script from "./postTwitter.vue?vue&type=script&lang=js&"
export * from "./postTwitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports